import { type JSX } from "react";
import { cn } from "../../lib/utils";
import { TooltipCell } from "../table/TooltipCell";
import { IconMaterial } from "../shared/iconMaterial/IconMaterial";
import { TMed, useMeds } from "../../context/MedDirProvider";
import DropdownMenu from "../dropdown/DropDownMenu";


type BodyTableProps = {
  id?: string | null;
  rows: TMed[];
  handleRowClick: (med: TMed) => void
  isPagination?: boolean;
  isLoadingSendInvitation: boolean;
  onEdit: () => void;
};

export const BodyTableMeds = ({
  rows,
  handleRowClick,
  onEdit
}: BodyTableProps): JSX.Element => {
  const baseCellClassName = cn(
    "p-[12px] typo-body-small-medium-14 text-black text-sm text-primary-light",
    "align-middle min-w-0",
  );

  const { selectedMed, setSelectedMed } = useMeds();

  return (
    <>
      {rows.map((med) => {
        return (
          <tr
            key={med.id}
            className={`${selectedMed?.id === med?.id ? 'bg-background-light-gray' : ''}`}
          >
            <td
              onClick={() => handleRowClick(med)}
              className={cn(
                baseCellClassName,
                "relative overflow-hidden cursor-pointer group",
                selectedMed?.id === med?.id ? "border-l-[2px] border-primeblue" : ""
              )}
            >
              <div className="rounded-l-lg flex items-center">
                <span className="truncate group-hover:text-primeblue">
                  {med.brand_name}
                </span>
                <IconMaterial
                  filled
                  icon="chevron_right"
                  className="cursor-pointer hidden group-hover:block group-hover:text-primeblue"
                  size={16}
                />
              </div>
            </td>

            <td className={cn(baseCellClassName)}>
              <TooltipCell content={med.dose_and_unit} />
            </td>

            <td className={cn(baseCellClassName)}>
              <TooltipCell content={med.concentration} />
            </td>

            <td className={`${baseCellClassName} relative  rounded-r-lg `}>
              <div className="flex justify-end items-center h-full w-full">
                <DropdownMenu
                  onEdit={() => {
                    setSelectedMed(med);
                    onEdit();
                  }}
                  onDetailView={() => handleRowClick(med)}
                />
              </div>
            </td>
          </tr>

        );
      })}
    </>
  );
};
